import "cruzo/ui-components/vars.css";
import "./css/rule-markup.css";
import "./css/colors.css";
import "./css/font.css";
import "./css/common.css";
import "./css/exercise-theme.css";
import "./css/typography.css";
import "cruzo/ui-components/margin.css";
import "./css/fx.css";
import "./css/icons.css";
import "./css/container.css";
import "./css/animation.css";

import "cruzo/ui-components/button.css";
import "cruzo/ui-components/checkbox.css";
import "cruzo/ui-components/input.css";
import "cruzo/ui-components/textarea.css";
import "cruzo/ui-components/modal.css";
import "cruzo/ui-components/spinner.css";
import "cruzo/ui-components/button-group.css";
import "cruzo/ui-components/select.css";
import "cruzo/ui-components/toast.css";
import "cruzo/ui-components/toast";

import { Template, componentsRegistryService, routerService } from "cruzo";

import "site/components/header/header.component";
import "site/components/lesson-bottom-bar/lesson-bottom-bar.component";
import "site/components/profile/profile.component";
import "site/components/subscription-manage/subscription-manage.component";
import "site/components/payment-status/payment-status.component";
import "site/icons/plus";
import "site/components/proofread-prompt-modal/proofread-prompt-modal.component";
import "site/components/editor-lock-modal/editor-lock-modal.component";
import "site/components/zepto-row-swap-modal/zepto-row-swap-modal.component";
import "site/components/suggest-new-words-modal/suggest-new-words-modal.component";
import "site/components/lesson-rules-modal/lesson-rules-modal.component";
import "site/components/lesson-words-modal/lesson-words-modal.component";
import "site/components/editor-lesson-rules-modal/editor-lesson-rules-modal.component";
import "site/components/create-rule-modal/create-rule-modal.component";
import "site/components/create-book-modal/create-book-modal.component";
import "site/components/lesson-translate-modal/lesson-translate-modal.component";
import "site/components/owner-payment-cancel-modal/owner-payment-cancel-modal.component";
import "site/components/owner-payment-receipt-modal/owner-payment-receipt-modal.component";
import "site/components/exercise-image-modal/exercise-image-modal.component";
import "site/components/image-gallery-modal/image-gallery-modal.component";
import "site/icons/channels";
import "site/icons/arabic";
import "site/icons/flash";
import "site/icons/open-book";
import "site/icons/paragraph";
import "site/icons/carbon-book";
import "site/icons/carbon-catalog";
import "site/icons/carbon-notebook-reference";

import "site/urls";
import { kickoffAuthSessionBootstrap } from "site/services/auth-session.service";
import { initI18n } from "site/services/i18n";

async function initApp() {
  routerService.setHashMode(true);
  initI18n();

  Template.setAppVariables({});
  kickoffAuthSessionBootstrap();
  componentsRegistryService.initApp();
  routerService.update();
}

void initApp();
